<template>
  <svg
    width="38"
    height="28"
    viewBox="0 0 38 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.3">
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="38"
        height="28"
      >
        <rect
          x="0.637482"
          y="0.953812"
          width="37.2283"
          height="26.7073"
          rx="13.3536"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M0.637482 1.69568C0.637482 1.28596 0.970835 0.953812 1.38205 0.953812L16.2734 0.953812C16.6846 0.953812 17.0179 1.28596 17.0179 1.69568V3.17942C17.0179 3.58914 16.6846 3.92129 16.2734 3.92129H1.38205C0.970836 3.92129 0.637482 3.58914 0.637482 3.17942V1.69568Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M0.637482 7.63063C0.637482 7.22091 0.970835 6.88876 1.38205 6.88876H10.3168C10.7281 6.88876 11.0614 7.22091 11.0614 7.63063V12.0818C11.0614 12.4916 10.7281 12.8237 10.3168 12.8237H1.38205C0.970836 12.8237 0.637482 12.4916 0.637482 12.0818V7.63063Z"
          fill="url(#paint1_linear)"
        />
        <path
          d="M0.637482 16.5331C0.637482 16.1233 0.970835 15.7912 1.38205 15.7912H10.3168C10.7281 15.7912 11.0614 16.1233 11.0614 16.5331V20.9843C11.0614 21.394 10.7281 21.7261 10.3168 21.7261H1.38205C0.970836 21.7261 0.637482 21.394 0.637482 20.9843L0.637482 16.5331Z"
          fill="url(#paint2_linear)"
        />
        <path
          d="M27.4419 7.63063C27.4419 7.22091 27.7752 6.88876 28.1864 6.88876L37.1212 6.88876C37.5324 6.88876 37.8658 7.22091 37.8658 7.63063V12.0818C37.8658 12.4916 37.5324 12.8237 37.1212 12.8237H28.1864C27.7752 12.8237 27.4419 12.4916 27.4419 12.0818V7.63063Z"
          fill="url(#paint3_linear)"
        />
        <path
          d="M17.0179 12.8237C17.0179 12.414 17.3513 12.0818 17.7625 12.0818H20.7408C21.152 12.0818 21.4853 12.414 21.4853 12.8237V15.7912C21.4853 16.2009 21.152 16.5331 20.7408 16.5331H17.7625C17.3513 16.5331 17.0179 16.2009 17.0179 15.7912V12.8237Z"
          fill="url(#paint4_linear)"
        />
        <path
          d="M27.4419 16.5331C27.4419 16.1233 27.7752 15.7912 28.1864 15.7912H37.1212C37.5324 15.7912 37.8658 16.1233 37.8658 16.5331V20.9843C37.8658 21.394 37.5324 21.7261 37.1212 21.7261H28.1864C27.7752 21.7261 27.4419 21.394 27.4419 20.9843V16.5331Z"
          fill="url(#paint5_linear)"
        />
        <path
          d="M21.4853 1.69568C21.4853 1.28596 21.8187 0.953812 22.2299 0.953812L37.1212 0.953812C37.5324 0.953812 37.8658 1.28596 37.8658 1.69568V3.17942C37.8658 3.58914 37.5324 3.92129 37.1212 3.92129H22.2299C21.8187 3.92129 21.4853 3.58914 21.4853 3.17942V1.69568Z"
          fill="url(#paint6_linear)"
        />
        <path
          d="M14.0397 1.69568C14.0397 1.28596 14.373 0.953812 14.7842 0.953812H16.2734C16.6846 0.953812 17.0179 1.28596 17.0179 1.69568V8.06521C17.0179 8.72614 16.2159 9.05714 15.7469 8.58979L14.2578 7.10605C14.1181 6.96692 14.0397 6.77822 14.0397 6.58147V1.69568Z"
          fill="url(#paint7_linear)"
        />
        <path
          d="M24.6817 7.41334C25.1507 6.94599 24.8185 6.14689 24.1552 6.14689H22.2299C21.8187 6.14689 21.4853 6.47904 21.4853 6.88876V8.80707C21.4853 9.46801 22.2873 9.799 22.7564 9.33165L24.6817 7.41334Z"
          fill="url(#paint8_linear)"
        />
        <path
          d="M37.8658 26.9192C37.8658 27.3289 37.5324 27.6611 37.1212 27.6611H22.2299C21.8187 27.6611 21.4853 27.3289 21.4853 26.9192V25.4355C21.4853 25.0257 21.8187 24.6936 22.2299 24.6936H37.1212C37.5324 24.6936 37.8658 25.0257 37.8658 25.4355V26.9192Z"
          fill="url(#paint9_linear)"
        />
        <path
          d="M17.0179 26.9192C17.0179 27.3289 16.6846 27.6611 16.2734 27.6611H1.38205C0.970836 27.6611 0.637482 27.3289 0.637482 26.9192V25.4355C0.637482 25.0257 0.970835 24.6936 1.38205 24.6936H16.2734C16.6846 24.6936 17.0179 25.0257 17.0179 25.4355V26.9192Z"
          fill="url(#paint10_linear)"
        />
        <path
          d="M24.4636 26.9192C24.4636 27.3289 24.1302 27.6611 23.719 27.6611H22.2299C21.8187 27.6611 21.4853 27.3289 21.4853 26.9192V20.5497C21.4853 19.8888 22.2873 19.5578 22.7564 20.0251L24.2455 21.5088C24.3852 21.648 24.4636 21.8367 24.4636 22.0334V26.9192Z"
          fill="url(#paint11_linear)"
        />
        <path
          d="M13.8216 21.2016C13.3525 21.6689 13.6847 22.468 14.3481 22.468H16.2734C16.6846 22.468 17.0179 22.1359 17.0179 21.7261V19.8078C17.0179 19.1469 16.2159 18.8159 15.7469 19.2832L13.8216 21.2016Z"
          fill="url(#paint12_linear)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-0.0734556"
        y1="13.0007"
        x2="37.4265"
        y2="13.0007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#979797" />
        <stop offset="1" stop-color="#666666" stop-opacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="-0.0734556"
        y1="13.0007"
        x2="37.4265"
        y2="13.0007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#979797" />
        <stop offset="1" stop-color="#666666" stop-opacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="-0.0734556"
        y1="13.0007"
        x2="37.4265"
        y2="13.0007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#979797" />
        <stop offset="1" stop-color="#666666" stop-opacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="-0.0734556"
        y1="13.0007"
        x2="37.4265"
        y2="13.0007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#979797" />
        <stop offset="1" stop-color="#666666" stop-opacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="-0.0734556"
        y1="13.0007"
        x2="37.4265"
        y2="13.0007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#979797" />
        <stop offset="1" stop-color="#666666" stop-opacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="-0.0734556"
        y1="13.0007"
        x2="37.4265"
        y2="13.0007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#979797" />
        <stop offset="1" stop-color="#666666" stop-opacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint6_linear"
        x1="-0.0734556"
        y1="13.0007"
        x2="37.4265"
        y2="13.0007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#979797" />
        <stop offset="1" stop-color="#666666" stop-opacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint7_linear"
        x1="-0.0734556"
        y1="13.0007"
        x2="37.4265"
        y2="13.0007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#979797" />
        <stop offset="1" stop-color="#666666" stop-opacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint8_linear"
        x1="-0.0734556"
        y1="13.0007"
        x2="37.4265"
        y2="13.0007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#979797" />
        <stop offset="1" stop-color="#666666" stop-opacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint9_linear"
        x1="-0.0734556"
        y1="13.0007"
        x2="37.4265"
        y2="13.0007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#979797" />
        <stop offset="1" stop-color="#666666" stop-opacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint10_linear"
        x1="-0.0734556"
        y1="13.0007"
        x2="37.4265"
        y2="13.0007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#979797" />
        <stop offset="1" stop-color="#666666" stop-opacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint11_linear"
        x1="-0.0734556"
        y1="13.0007"
        x2="37.4265"
        y2="13.0007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#979797" />
        <stop offset="1" stop-color="#666666" stop-opacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint12_linear"
        x1="-0.0734556"
        y1="13.0007"
        x2="37.4265"
        y2="13.0007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#979797" />
        <stop offset="1" stop-color="#666666" stop-opacity="0.5" />
      </linearGradient>
    </defs>
  </svg>
</template>
